import ajax from '@vhcl/shared/ajax';

const regex = /^(http:\/\/|https:\/\/|\/\/)/;

// 定义该模块的请求头
const reqHeader = {
  'Content-Type': 'application/json'
};
// 定义该模块的请求基础ULR
let reqBaseUrl = window?.$hcl?.currentEnvOpt?.baseUrl;

// 支持模块级别个性化设置请求头和请求URL
export const updateRequestConfig = options => {
  if (!options || typeof options !== 'object') return;

  // 覆盖统一的请求头
  if (typeof options.header === 'object') {
    Object.assign(reqHeader, header);
  }

  // 覆盖请求URL
  if (typeof options.baseUrl === 'string' && options.baseUrl) {
    reqBaseUrl = options.baseUrl;
  }
};

/**
 * 二次封装http请求
 * @param {object} options
 *  - options.url
 *  - options.method
 *  - options.params
 *  - options.header
 *  - options.async
 * @returns
 */
export function request({ url, method, params, header, async }) {
  if (typeof header == 'object') {
    Object.assign(reqHeader, header);
  }

  if (typeof reqBaseUrl === 'undefined' && window?.$hcl?.currentEnvOpt) {
    // 处理 HCL 环境初始化滞后导致 reqBaseUrl 初始化为undefined的问题
    reqBaseUrl = window.$hcl.currentEnvOpt.baseUrl || '';
  }

  if (typeof reqBaseUrl === 'undefined') {
    throw new Error(`You need to call the setGlobalEnv method in @vhcl/core to initialize`);
  }

  // 如果请求地址不是 'http://', 'https://', '//'开头，补充前缀
  if (!regex.test(url)) {
    url = `${reqBaseUrl || ''}${url}`;
  }

  return ajax({
    url,
    method,
    params,
    async,
    header: reqHeader
  });
}
